<div class="main-footer">
  Powered by Cavallino Bianco Caorle - Venezia {{year}}
</div>
